<template>
	<v-container>
		<v-col cols="12" class="d-flex justify-space-between pb-2 pt-0 pl-0">
			<div
				:class="{
					'settings-heading': !$vuetify.theme.dark,
					'settings-heading-dark-theme': $vuetify.theme.dark,
				}"
			>
				{{ $t('labels.settings') }}
			</div>
			<v-btn icon @click="closeSettings">
				<v-icon small>fa-x</v-icon>
			</v-btn>
		</v-col>
		<v-divider></v-divider>

		<v-row class="pl-2 pb-0">
			<div :class="{ 'label-text': !$vuetify.theme.dark, 'label-text-dark-theme': $vuetify.theme.dark }">
				{{ $t('labels.theme') }}
			</div>
		</v-row>
		<v-row class="pt-0 pl-6 pr-4">
			<v-col cols="6" class="pt-0">
				<v-row
					class="settings-button"
					:class="{ 'active-btn-color': !$vuetify.theme.dark }"
					@click="setLightTheme"
				>
					<v-col class="d-flex justify-center">
						{{ $t('labels.light') }} &nbsp;&nbsp;<v-icon small color="icon">fa-sun</v-icon>
					</v-col>
				</v-row>
			</v-col>
			<v-col cols="6" class="pt-0" @click="setDarkTheme">
				<v-row class="settings-button" :class="{ 'active-btn-color': $vuetify.theme.dark }">
					<v-col class="d-flex justify-center">
						{{ $t('labels.dark') }} &nbsp;&nbsp;<v-icon small>fa-moon</v-icon>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
		<v-divider></v-divider>

		<v-row class="pl-2 pb-0">
			<div :class="{ 'label-text': !$vuetify.theme.dark, 'label-text-dark-theme': $vuetify.theme.dark }">
				{{ $t('labels.fontSize') }}
			</div>
		</v-row>
		<v-row class="pt-0 pl-6 pr-4">
			<v-col cols="6" class="pt-0" @click="setSmallFont">
				<v-row class="settings-button" :class="{ 'active-btn-color': !$myStore.state.largeFont }">
					<v-col class="d-flex justify-center">
						{{ $t('labels.small') }}&nbsp;&nbsp;<v-icon
							small
							:class="{ 'active-icon-color': !$myStore.state.largeFont }"
							>fa-a</v-icon
						>
					</v-col>
				</v-row>
			</v-col>
			<v-col cols="6" class="pt-0" @click="setLargeFont">
				<v-row class="settings-button" :class="{ 'active-btn-color': $myStore.state.largeFont }">
					<v-col class="d-flex justify-center">
						{{ $t('labels.large') }}&nbsp;&nbsp;<v-icon
							big
							:class="{ 'active-icon-color': $myStore.state.largeFont }"
							>fa-a</v-icon
						>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
		<v-divider></v-divider>

		<v-row class="pl-2 pb-0">
			<div :class="{ 'label-text': !$vuetify.theme.dark, 'label-text-dark-theme': $vuetify.theme.dark }">
				{{ $t('labels.dyslexicFont') }}
			</div>
		</v-row>
		<v-row class="pt-0 pl-6 pr-4">
			<v-col cols="6" class="pt-0" @click="setRegularFont">
				<v-row class="settings-button" :class="{ 'active-btn-color': !$myStore.state.dyslexicFont }">
					<v-col class="d-flex justify-center">
						{{ $t('labels.no') }}&nbsp;&nbsp;<v-icon
							small
							:class="{ 'active-icon-color': !$myStore.state.dyslexicFont }"
							>fa-x</v-icon
						>
					</v-col>
				</v-row>
			</v-col>
			<v-col cols="6" class="pt-0" @click="setDyslexicFont">
				<v-row class="settings-button" :class="{ 'active-btn-color': $myStore.state.dyslexicFont }">
					<v-col class="d-flex justify-center">
						{{ $t('labels.yes') }}&nbsp;&nbsp;<v-icon
							small
							:class="{ 'active-icon-color': $myStore.state.dyslexicFont }"
							>fa-check</v-icon
						>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
		<v-divider></v-divider>
	</v-container>
</template>

<script>
export default {
	name: 'AccessibilitySettings',
	props: {
		drawer: Boolean,
	},
	emits: ['closeSettings'],
	data() {
		return {
			settingsDrawer: this.drawer,
		};
	},
	computed: {},
	watch: {},
	methods: {
		closeSettings() {
			this.$emit('closeSettings');
		},
		setDarkTheme() {
			if (this.$vuetify.theme.dark != true) {
				this.$vuetify.theme.dark = true;
				this.saveSettings({ dark_theme: true });
			}
		},
		setLightTheme() {
			if (this.$vuetify.theme.dark != false) {
				this.$vuetify.theme.dark = false;
				this.saveSettings({ dark_theme: false });
			}
		},
		setLargeFont() {
			if (this.$myStore.state.largeFont != true) {
				this.$myStore.state.largeFont = true;
				this.saveSettings({ large_font: true });
			}
		},
		setSmallFont() {
			if (this.$myStore.state.largeFont != false) {
				this.$myStore.state.largeFont = false;
				this.saveSettings({ large_font: false });
			}
		},
		setDyslexicFont() {
			if (this.$myStore.state.dyslexicFont != true) {
				this.$myStore.state.dyslexicFont = true;
				this.saveSettings({ dyslexic_font: true });
			}
		},
		setRegularFont() {
			if (this.$myStore.state.dyslexicFont != false) {
				this.$myStore.state.dyslexicFont = false;
				this.saveSettings({ dyslexic_font: false });
			}
		},
		saveSettings(payload) {
			let vm = this;

			this.$APICall(
				'put',
				'users/settings/' + this.$myStore.state.user.id,
				payload,
				(data, success) => {
					if (!success) {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
	},
	mounted() {},
};
</script>

<style scoped>
.settings-button {
	border: 1px solid #e0e0e0;
	border-radius: 4px;
	margin-bottom: 4px;
	margin-right: 4px;
	cursor: pointer;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.active-btn-color {
	background-color: #009ec0;
	color: white;
	border-color: #009ec0;
}

.active-icon-color {
	color: white;
}

.label-text {
	color: #616161;
	margin: 16px 0 2px 16px;
}

.label-text-dark-theme {
	color: #a5a5a5;
	margin: 16px 0 2px 16px;
}

.settings-heading {
	display: inline-block;
	margin: 24px 0px 8px 12px;
	font-size: 20px;
	color: #616161;
}

.settings-heading-dark-theme {
	display: inline-block;
	margin: 24px 0px 8px 12px;
	font-size: 20px;
	color: #a5a5a5;
}
</style>
